<form nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()">
    @if(modalData.displayInput.includes('password')) {
    <nz-form-item>
        <nz-form-label nzFor="password" [nzSpan]="12" [nzRequired]="true">Password</nz-form-label>
        <nz-form-control [nzErrorTip]="passwordError">
            <nz-input-group [nzPrefix]="passwordIcon" [nzSuffix]="suffixTemplate">
                <input nz-input type="password" name="password" id="password" formControlName="password"
                    placeholder="Enter Password" [maxlength]="10" appNoSpaces="nospace" autocomplete="current-password"
                    [type]="passwordVisible ? 'text' : 'password'" />
            </nz-input-group>
        </nz-form-control>
        <ng-template #passwordIcon>
            <span nz-icon nzType="lock" aria-hidden="true"></span>
        </ng-template>
        <ng-template #suffixTemplate>
            <button type="button" aria-label="Toggle Password Visibility" (click)="passwordVisible = !passwordVisible">
                <span nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'" aria-hidden="true"></span>
            </button>
        </ng-template>
        <ng-template #passwordError let-control>
            @if (control.errors?.['required']) { Password is required! }
        </ng-template>
    </nz-form-item>
    }
    @if(modalData.displayInput.includes('remarks')) {
    <nz-form-item>
        <nz-form-control [nzErrorTip]="remarksError">
            <nz-form-label nzFor="remarks" [nzSpan]="12" [nzRequired]="true">Remarks</nz-form-label>
            <nz-textarea-count [nzMaxCharacterCount]="100">
                <textarea name="remarks" id="remarks" class="w-full" placeholder="Enter remarks"
                    formControlName="remarks" [maxlength]="100" rows="3" nz-input></textarea>
            </nz-textarea-count>
        </nz-form-control>
        <ng-template #remarksError let-control>
            @if (control.errors?.['required']) { Remarks is required! }
            @if (control.errors?.['minlength']) { Remarks must be at least 3 characters long! }
        </ng-template>
    </nz-form-item>
    }
</form>
<nz-alert *ngIf="isInvalid" nzShowIcon nzType="error" nzMessage="Invalid Password"></nz-alert>
<div *nzModalFooter>
    <button nz-button nzType="default" type="button" (click)="modal.destroy(null)">Cancel</button>
    <button nz-button nzType="primary" type="submit" (click)="submitForm()">Submit</button>
</div>